import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import { withTranslation, Trans } from 'react-i18next';
import ToogleButton from '../../controls/buttons/toogle_button.jsx';
import ExtendedIo from '../controls/extended_io.jsx';
import * as styles from "../tanks.module.scss";
import * as FileSaver from 'file-saver';

const emptyIo = {
    deviceAdditionalIoId: 0,
    deviceImei: "",
    dataType: "int",
    ioTypeId: 1,
    ioAddress: "",
    defaultValue: "",
    offset: 0,
    ratio: 1,
    dataDelta: 0,
    ioDataActionId: 0,
    ioDataActionParam: ""
};

class EditTank extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.item
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancelEditTank = this.cancelEditTank.bind(this);
        this.updateIoData = this.updateIoData.bind(this);
        this.addAdditionalIo = this.addAdditionalIo.bind(this);
        this.removeIo = this.removeIo.bind(this);
        this.updateTank = this.updateTank.bind(this);
        this.updateDevice = this.updateDevice.bind(this);
        this.convertValue = this.convertValue.bind(this);
        this.updateGraduations = this.updateGraduations.bind(this);
        this.downloadGraduationsFile = this.downloadGraduationsFile.bind(this);
        this.removeGraduations = this.removeGraduations.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (state.item !== props.item)
            return { ...state, item: props.item };
        else {
            return null;
        }
    }

    componentDidMount() {
        this.props.getTank(this.props.match.params.id);
    }

    addAdditionalIo(e) {
        e.preventDefault();
        const item = this.state.item;
        const io = Object.assign({}, emptyIo);
        io.ioTypeId = parseInt(this.refs.selectIoTypes.value);
        io.deviceImei = item.device.deviceImei;
        item.device.deviceExtendedIos.push(io);
        this.setState({ ...this.state, item: item });
    }

    removeIo(io) {
        const item = this.state.item;
        item.device.deviceExtendedIos = item.device.deviceExtendedIos.filter((value, index, arr) => value !== io);
        this.setState({ ...this.state, item: item });
    }

    updateGraduations(file) {
        if (file) {
            this.setState({ ...this.state, graduationFile: file });
        }
    }

    removeGraduations() {
        const state = this.state;
        if (state.item.graduationFileId) {
            state.item.graduationFileId = null;
        }

        if (state.graduationFile) {
            state.graduationFile = null;
        }

        this.setState(state);
    }

    downloadGraduationsFile() {
        this.props.downloadGraduationsFile(this.state.item.graduationFileId).then(data => {
            FileSaver.saveAs(data.file, data.fileName);
        });;
    }

    updateIoData(io, index) {
        const item = this.state.item;
        item.device.deviceExtendedIos = item.device.deviceExtendedIos.map((item, i) => i === index ? io : item);
        this.setState({ ...this.state, item: item });
    }

    updateDeviceIoSettingsState(propName, propValue) {
        const state = Object.assign({}, this.state);
        let deviceIoSettings = state.item.device.deviceIoSettings;
        deviceIoSettings[propName] = propValue;
        state.item.device.deviceIoSettings = deviceIoSettings;
        this.setState(state);
    }

    updateTank(propName, strValue, dataType) {
        const state = Object.assign({}, this.state);

        state.item[propName] = this.convertValue(strValue, dataType);
        this.setState(state);
    }

    updateDevice(propName, value, dataType) {
        const state = Object.assign({}, this.state);

        state.item.device[propName] = this.convertValue(value, dataType);
        this.setState(state);
    }

    convertValue(value, dataType) {
        if (dataType === "int") {
            return parseInt(value);
        }
        if (dataType === "float") {
            return parseFloat(value);
        }

        return value;
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.props.isNewTank) {
            this.props.addTank(this.state.item, this.state.graduationFile);
        } else {
            this.props.editTank(this.state.item, this.state.graduationFile);
        }
    }

    cancelEditTank(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    getIoTypeTranslatedName(ioTypeName) {
        switch (ioTypeName) {
        case "WatterLevelHeight":
            return this.props.i18n.t("ExtendedIo.watterLevelHeightIoName");
        case "WatterLevelVolume":
            return this.props.i18n.t("ExtendedIo.watterLevelVolumeIoName");
        case "ProductLevelHeight":
            return this.props.i18n.t("ExtendedIo.productLevelHeightIoName");
        case "ProducLevelVolume":
            return this.props.i18n.t("ExtendedIo.producLevelVolumeIoName");
        case "Temperature":
            return this.props.i18n.t("ExtendedIo.temperatureIoName");
        case "Density":
            return this.props.i18n.t("ExtendedIo.densityIoName");
        case "Pressure":
                return this.props.i18n.t("ExtendedIo.pressureIoName");
        case "Weight":
            return this.props.i18n.t("ExtendedIo.weightIoName");
        case "WatterLevelHeightQuality":
            return this.props.i18n.t("ExtendedIo.watterLevelHeightIoQualityName");
        case "WatterLevelVolumeQuality":
            return this.props.i18n.t("ExtendedIo.watterLevelVolumeIoQualityName");
        case "ProductLevelHeightQuality":
            return this.props.i18n.t("ExtendedIo.productLevelHeightIoQualityName");
        case "ProducLevelVolumeQuality":
            return this.props.i18n.t("ExtendedIo.producLevelVolumeIoQualityName");
        case "TemperatureQuality":
            return this.props.i18n.t("ExtendedIo.temperatureIoQualityName");
        case "DensityQuality":
            return this.props.i18n.t("ExtendedIo.densityIoQualityName");
        case "PressureQuality":
                return this.props.i18n.t("ExtendedIo.pressureIoQualityName");
        case "WeightQuality":
            return this.props.i18n.t("ExtendedIo.weightIoQualityName");

        default:
            return "";
        }
    }

    getIoTypeTranslatedNameById(ioId) {
        const ioTypeName = this.getIoTypeNameById(ioId);
        return this.getIoTypeTranslatedName(ioTypeName);
    }

    getIoTypeNameById(ioId) {
        const ioTypes = this.props.ioTypes;
        return ioTypes.find((item) => {
            return item.ioTypeId === ioId;
        }).ioTypeName;
    }

    isFieldAccess(fieldName, access) {
        if (this.props.isNewTank) return true;

        const fieldAccess = this.props.appFieldsAccess[fieldName];
        if (fieldAccess && fieldAccess >= access) return true;

        return false;
    }

    render() {
        const ioTypes = this.props.ioTypes;
        const deviceExtendedIos = this.state.item.device.deviceExtendedIos;
        let graduationFiles = [];
        if (this.state.graduationFile) {
            graduationFiles.push(this.state.graduationFile);
        }
        const presentIoTypes = ioTypes.filter((item) => {
            return (deviceExtendedIos.find((d) => d.ioTypeId === item.ioTypeId)) ? false : true;
        });
        return (
            <div className="form_container">
                <form className="edit-tank" onSubmit={this.handleSubmit}>
                    <div className="form-body flex-column-border-content">
                        <div id="tankSettings">
                            <div className="flex margin10">
                                <div>
                                    <div className="inline">
                                        <label><Trans>Tanks.areaName</Trans></label>
                                        <select ref="areaId" value={this.state.item.areaId} onChange={(e) => this.updateTank("arreaId", e.target.value, "int")}>
                                            {
                                                this.props.areas &&
                                                this.props.areas.map((item, index) =>
                                                    (
                                                        <option className="select_option" key={index} value={item.areaId}>
                                                            {item.areaName}</option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.tankName</Trans></label>
                                        <input type="text" value={this.state.item.tankName} onChange={(e) => this.updateTank("tankName", e.target.value)} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.department</Trans></label>
                                        <input type="text" value={this.state.item.department} onChange={(e) => this.updateTank("department", e.target.value)} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.fuelType</Trans></label>
                                        <input type="text" value={this.state.item.fuelType} onChange={(e) => this.updateTank("fuelType", e.target.value)} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.minLevel</Trans></label>
                                        <input type="number" value={this.state.item.minLevel} onChange={(e) => this.updateTank("minLevel", e.target.value, "float")} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.maxLevel</Trans></label>
                                        <input type="number" value={this.state.item.maxLevel} onChange={(e) => this.updateTank("maxLevel", e.target.value, "float")} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.volume</Trans></label>
                                        <input type="number" value={this.state.item.volume} onChange={(e) => this.updateTank("volume", e.target.value, "float")} />
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Tanks.graduations</Trans></label>
                                        <div className="flex">
                                            {
                                                this.state.item.graduationFileId || this.state.graduationFile ? <div className="check-background-green"></div> : <div className="close-background-red"></div>
                                            }
                                            <label className="file-upload-button" htmlFor="upload-graduations-file">
                                            </label>
                                            <input type="file" id='upload-graduations-file' onChange={(e) => this.updateGraduations(e.target.files[0])} style={{display:'none'}}/>
                                            {
                                                this.state.item.graduationFileId &&
                                                <button className="app-button-style file-download-button" onClick={(e) => { e.preventDefault(); this.downloadGraduationsFile() }}></button>
                                            }
                                            {
                                                (this.state.item.graduationFileId || this.state.graduationFile) && (
                                                    <button className="app-button-style file-remove-button" onClick={(e) => {e.preventDefault(); this.removeGraduations();}}></button>
                                                )
                                            }
                                         </div>
                                        

                                    </div>
                                </div>
                                <div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceImei</Trans></label>
                                        <input type="text" value={this.state.item.device.deviceImei} disabled={!this.props.isNewTank}
                                             onChange={(e) => this.updateDevice("deviceImei", e.target.value)}/>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Devices.name</Trans></label>
                                        <input type="text" value={this.state.item.device.name} onChange={(e) => this.updateDevice("name", e.target.value)}/>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Devices.description</Trans></label>
                                        <input type="text" value={this.state.item.device.description} onChange={(e) => this.updateDevice("description", e.target.value)}/>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceType</Trans></label>
                                        <select value={this.state.item.device.deviceTypeId} onChange={(e) => this.updateDevice("deviceTypeId", e.target.value, "int")}>
                                            {
                                                this.props.deviceTypes &&
                                                this.props.deviceTypes.map((item, index) =>
                                                    (
                                                        <option className="select_option" key={index} value={item.deviceTypeId}>
                                                            {item.deviceTypeDesc}</option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="toogle-element inline">
                                        <label><Trans>Devices.isActive</Trans></label>
                                        <ToogleButton value={this.state.item.device.isActive} onChange={(checked) => this.updateDevice("isActive", checked)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="deviceIoSettings">
                            <div className="flex margin10">
                                <div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceIoSettings.volumeCountIoId</Trans></label>
                                        <input type="number" value={this.state.item.device.deviceIoSettings.volumeCountIoId}
                                               onChange={(e) => this.updateDeviceIoSettingsState("volumeCountIoId", e.target.value)}/>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceIoSettings.volumeRatio</Trans></label>
                                        <input type="number" step="0.01" value={this.state.item.device.deviceIoSettings.volumeRatio} onChange={(e) => this.updateDeviceIoSettingsState("volumeRatio", e.target.value)}/>
                                    </div>
                                </div>
                                <div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceIoSettings.valveIoId</Trans></label>
                                        <input type="number" value={this.state.item.device.deviceIoSettings.valveIoId} onChange={(e) => this.updateDeviceIoSettingsState("valveIoId", e.target.value)}/>
                                    </div>
                                    <div className="inline">
                                        <label><Trans>Devices.deviceIoSettings.userKeyIoId</Trans></label>
                                        <input type="number" value={this.state.item.device.deviceIoSettings.userKeyIoId} onChange={(e) => this.updateDeviceIoSettingsState("userKeyIoId", e.target.value)}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div id="deviceExtendedIoSettings" className="no-flex-border">
                            <div >
                                <div className="no-flex-border margin10 marginTop30" style={{ fontSize: "18px" }}>
                                    <Trans>ExtendedIo.EditTankHeader</Trans>
                                </div>

                            </div>
                            <div className="flex-column-border-content">
                                {
                                    this.state.item.device.deviceExtendedIos && this.state.item.device.deviceExtendedIos.filter(
                                        i => {
                                            return this.isFieldAccess(this.getIoTypeNameById(i.ioTypeId), 2);
                                        }).map(
                                        (item, index) => {
                                            const ioIndex = index;
                                                return <div key={index} style={{ position: "relative" }}>
                                                    <ExtendedIo key={index}
                                                        ioTypeName={this.getIoTypeNameById(item.ioTypeId)}
                                                        ioDataTypes={["int", "float", "string"]}
                                                        ioActionTypes={this.props.ioActionTypes}
                                                        io={item}
                                                        canBeEdit={this.isFieldAccess("EditExtendedIoList", 2)}
                                                        changed={(item) => this.updateIoData(item, ioIndex)}
                                                        removeIoAction={this.removeIo} />
                                                </div>;
                                        }
                                    )
                                }
                                {this.isFieldAccess("EditExtendedIoList", 2) && presentIoTypes && presentIoTypes.length > 0 && <div className="inline marginTop30 no-flex-border">
                                    <label><Trans>ExtendedIo.ioType</Trans></label>
                                    <select ref="selectIoTypes" defaultValue="0">
                                        {
                                            presentIoTypes.map((item, index) =>
                                                (
                                                    <option className="select_option" key={index} value={item.ioTypeId}>
                                                        {this.getIoTypeTranslatedName(item.ioTypeName)}</option>
                                                )
                                            )
                                        }
                                    </select>
                                    <div style={{position: "relative", height: "31px", width: "60px", marginLeft: "10px"}}>
                                        <button className={styles.add_item_button} style={{position: "unset"}} onClick={this.addAdditionalIo}></button>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-buttons-container">
                        <button type="submit"><Trans>Table.saveButton</Trans></button>
                        <button onClick={this.cancelEditTank}><Trans>Table.cancelButton</Trans></button>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const isNewTank = !state.tanks.currentTank || state.tanks.currentTank.tankId === 0;
    const item = state.tanks.currentTank;
    if (isNewTank) {
        let areaId = item.areaId;
        if (ownProps.match.params.areaId) {
            areaId = parseInt(ownProps.match.params.areaId);
        }
        item.areaId = areaId;
    };

    return {
        ...ownProps,
        item: item,
        areas: state.tanks.areas,
        isNewTank: isNewTank,
        ioTypes: state.app.ioTypes,
        deviceTypes: state.app.deviceTypes,
        ioActionTypes: state.app.ioActionTypes,
        appFieldsAccess: state.app.appFieldsAccess
    }
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        editTank: (tank, graduationFile) => dispatch(actionTanks.editTank(tank, graduationFile, ownProps)),
        addTank: (tank, graduationFile) => dispatch(actionTanks.addTank(tank, graduationFile, ownProps)),
        getTank: tankId => dispatch(actionTanks.getTank(tankId)),
        downloadGraduationsFile: (fileId) => dispatch(actionTanks.getGraduationsFile(fileId))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation('translantions')(EditTank)));